interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  actionLabel?: string;
  actionHref?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  actionLabel,
  actionHref,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-4 border-b border-foreground-200/80 pb-5 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        <span className="font-label text-[11px] uppercase tracking-[0.34em] text-primary-600">
          {eyebrow}
        </span>
        <h2 className="mt-2 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[32px]">
          {title}
        </h2>
        {desc ? (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">{desc}</p>
        ) : null}
      </div>
      {actionLabel && actionHref ? (
        <a
          href={actionHref}
          className="group inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md border border-foreground-200 px-4 py-2 font-label text-sm text-foreground-700 transition-colors duration-200 hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
        >
          {actionLabel}
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-line text-base transition-transform duration-200 group-hover:translate-x-0.5" />
          </span>
        </a>
      ) : null}
    </div>
  );
}